import { ReactNode } from 'react'

import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { useComposerConfig } from '../ComposerConfigContext.js'
import { useComposer } from '../hooks/useComposer.js'

import { AttachmentPickerButton } from './AttachmentPickerButton.js'
import { ComposerIconButton } from './ComposerIconButton.js'
import { EmojiPickerButton } from './EmojiPickerButton.js'
import { SlashMenuButton } from './SlashMenuButton.js'
import { TextFormattingMenu } from './TextBubbleMenu.js'

export type ComposerControlsProps = {
  action?: ReactNode
}
export const ComposerControls = (props: ComposerControlsProps) => {
  const { action } = props

  const { editor, onSlashMenuItemClick, toggleDialog, state } = useComposer()
  const { extensions } = useComposerConfig()

  if (!editor) {
    return null
  }

  return (
    <div className="space-y-1">
      {editor && state.textFormatMenu && (
        <TextFormattingMenu
          editor={editor}
          className="shadow-none border-none px-0 overflow-x-auto"
        />
      )}

      <div className="justify-between flex items-end">
        <div className="flex gap-1 items-center">
          <SlashMenuButton
            size="md"
            onItemClick={props => {
              setTimeout(() => {
                onSlashMenuItemClick({
                  editor,
                  props,
                })
              }, 100)
            }}
          />
          <div className="hidden sm:flex">
            <ComposerIconButton
              icon={<SvgIcon name="font-size" />}
              size="md"
              aria-label="text formatting"
              onClick={() => {
                toggleDialog('textFormatMenu', !state.textFormatMenu)
              }}
              className={
                state.textFormatMenu
                  ? 'bg-surface-subdued hover:bg-surface-subdued-hovered'
                  : ''
              }
            />
          </div>
          <div className="hidden md:flex">
            {extensions.emoji && (
              <EmojiPickerButton size="md" editor={editor} />
            )}
          </div>
          {extensions.image && (
            <ComposerIconButton
              size="md"
              icon={<SvgIcon name="image" />}
              aria-label="image"
              onClick={() => {
                toggleDialog('image', true)
              }}
            />
          )}
          <div className="hidden md:flex">
            {extensions.attachment && <AttachmentPickerButton size="md" />}
          </div>
        </div>

        {action && <div className="flex items-center ms-2">{action}</div>}
      </div>
    </div>
  )
}
